import { Slider } from '@/core/ui/atoms/slider'
import { getCities } from './cities'
import { City } from './city'

type Props = {
  className?: string
}

export const ExploreCities: React.FC<Props> = async ({ className = '' }) => {
  const cities = await getCities()

  return (
    <section className={className} aria-labelledby='explore-cities-title'>
      <h4
        id='explore-cities-title'
        className='mb-6 text-center text-2xl font-bold'
      >
        Explore cities
      </h4>

      {/* Desktop Grid */}
      <ul className='hidden grid-cols-12 grid-rows-4 gap-3 md:grid'>
        {/* Row 1 */}
        <li className='col-span-3 row-start-1 h-52'>
          <City {...cities[0]} />
        </li>
        <li className='col-span-4 row-start-1 h-52'>
          <City {...cities[1]} />
        </li>
        <li className='col-span-5 row-start-1 h-52'>
          <City {...cities[2]} />
        </li>

        {/* Row 2 */}
        <li className='col-span-2 row-start-2 h-52'>
          <City {...cities[3]} />
        </li>
        <li className='col-span-3 row-start-2 h-52'>
          <City {...cities[4]} />
        </li>
        <li className='col-span-2 row-start-2 h-52'>
          <City {...cities[5]} />
        </li>
        <li className='col-span-3 row-start-2 h-52'>
          <City {...cities[6]} />
        </li>
        <li className='bg-sky-blue text-navy col-span-2 col-start-6 row-start-2 flex h-52 flex-col justify-center rounded-md p-2 text-3xl font-bold'>
          <p>Explore</p>
          <p>Book</p>
          <p className='text-red'>Go..</p>
        </li>

        {/* Row 3 */}
        <li className='col-span-4 row-start-3 h-52'>
          <City {...cities[7]} />
        </li>
        <li className='col-span-4 row-start-3 h-52'>
          <City {...cities[8]} />
        </li>
        <li className='col-span-4 row-start-3 h-52'>
          <City {...cities[9]} />
        </li>

        {/* Row 4 */}
        <li className='col-span-4 row-start-4 h-52'>
          <City {...cities[10]} />
        </li>
        <li className='col-span-4 row-start-4 h-52'>
          <City {...cities[11]} />
        </li>
        <li className='col-span-4 row-start-4 h-52'>
          <City {...cities[12]} />
        </li>
      </ul>

      {/* Mobile Slider */}
      <div className='h-full md:hidden'>
        <Slider
          slides={cities.map(city => (
            <div className='h-full pe-3' key={city.slug}>
              <City {...city} />
            </div>
          ))}
          breakpoints={{
            768: 2,
            480: 1,
          }}
        />
      </div>
    </section>
  )
}
